import { render, staticRenderFns } from "./flowDetails.vue?vue&type=template&id=1251d908&scoped=true&"
import script from "./flowDetails.vue?vue&type=script&lang=js&"
export * from "./flowDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1251d908",
  null
  
)

export default component.exports